import { Logo } from "@/components/Logo";

// Minimal editorial top bar used across the flow.
export function TopBar({ right = null, dark = false, step = null }) {
  return (
    <header
      className={`sticky top-0 z-40 w-full border-b ${
        dark ? "border-white/10 bg-black" : "border-neutral-200 bg-white"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Logo light={dark} />
        <div className="flex items-center gap-6">
          {step && (
            <span className={`tw-eyebrow hidden sm:inline ${dark ? "text-neutral-500" : ""}`}>
              {step}
            </span>
          )}
          {right}
        </div>
      </div>
    </header>
  );
}
